export const offersCategory = (name, depth) =>
  depth === 1 &&
  name &&
  (name.toLowerCase().includes('offers') ||
    name.toLowerCase().includes('deals') ||
    name.toLowerCase().includes('black friday'));
